import { render, staticRenderFns } from "./RecentGroupPost.vue?vue&type=template&id=2ebacac1"
import script from "./RecentGroupPost.vue?vue&type=script&lang=js"
export * from "./RecentGroupPost.vue?vue&type=script&lang=js"
import style0 from "./RecentGroupPost.vue?vue&type=style&index=0&id=2ebacac1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports